<app-page-header
    title="Gestión de Vehículos"
    [mobileTitle]="title"
    icon="fas fa-car"
    [showBack]="true"
    [unifiedOnMobile]="true"
    (back)="close()">
</app-page-header>

@if (appSettings.isMobile()) {
<app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm"
        [disabled]="form.invalid || loading()"
        (click)="save()">
        Guardar
    </button>
</app-mobile-footer>
}

<div class="panel p-3 mb-3">
    <h5 class="mb-3">{{ mode() === formMode.CREATE ? 'Nuevo modelo' : 'Editar modelo' }}</h5>
    @if (loading()) {
        <div class="text-muted small">Cargando…</div>
    } @else {
    <form [formGroup]="form">
        <div class="mb-3">
            <label class="form-label">Marca</label>
            <ng-select [items]="brands" bindLabel="name" bindValue="code" formControlName="brandCode"
                placeholder="Seleccione Marca" (change)="refreshCode()"></ng-select>
        </div>

        <div class="row">
            <div class="col-md-6 mb-3">
                <label for="year" class="form-label">Año</label>
                <input type="number" id="year" class="form-control" formControlName="year" (input)="refreshCode()">
            </div>
            <div class="col-md-6 mb-3">
                <label for="vehicleType" class="form-label">Tipo Vehículo</label>
                <ng-select [items]="vehicleTypeData" bindLabel="type" bindValue="type" formControlName="vehicleType"
                    placeholder="Seleccione Tipo Vehículo">
                </ng-select>
            </div>
        </div>

        <div class="mb-3">
            <label for="code" class="form-label">Código</label>
            <input type="number" id="code" class="form-control" formControlName="code" readonly>
            @if (mode() === formMode.CREATE) {
            <small class="text-muted">Se genera solo: marca + año + correlativo.</small>
            }
        </div>

        <div class="mb-3">
            <label for="name" class="form-label">Nombre</label>
            <input type="text" id="name" class="form-control" formControlName="name">
        </div>

        <div class="mb-3 form-check">
            <input type="checkbox" class="form-check-input" id="isActive" formControlName="isActive">
            <label class="form-check-label" for="isActive">Activo</label>
        </div>
    </form>

    @if (!appSettings.isMobile()) {
    <div class="d-flex justify-content-end gap-2 mt-3">
        <button type="button" class="btn btn-secondary btn-sm" (click)="close()">Cancelar</button>
        <button type="button" class="btn btn-primary btn-sm" [disabled]="form.invalid" (click)="save()">
            Guardar
        </button>
    </div>
    }
    }
</div>
